import { defineMessages } from 'react-intl';

export const i18n: {
	type: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	filterTypePlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	filterLabelSelected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	filterLabelUnselected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	type: {
		id: 'quick-find.filters.names.type',
		defaultMessage: 'Type',
		description:
			'Label shown on the content type filter dropdown button in the Quick Find dialog, allowing users to narrow search results by a specific content type (e.g. page, issue, space).',
	},
	filterTypePlaceholder: {
		id: 'quick-find.filter.type.placeholder',
		defaultMessage: 'Find type',
		description: 'Placeholder for type filter search input',
	},
	filterLabelSelected: {
		id: 'quick-find.filter.type.label.selected',
		defaultMessage: 'Selected',
		description:
			'Group heading shown in the content type filter dropdown in Quick Find to separate already-selected content types from available ones.',
	},
	filterLabelUnselected: {
		id: 'quick-find.filter.type.label.unselected',
		defaultMessage: 'Available',
		description:
			'Group heading shown in the content type filter dropdown in Quick Find to label content types that are available but not yet selected.',
	},
});
